<div class="myDiv">
  <h3 mat-dialog-header>{{ settings.lang.familyGroups }}</h3>
  <div mat-dialog-content>
    <div class="dialog-content-fixer">
      <mat-nav-list role="list">
        <mat-list-item
          *ngFor="let g of availableGroups"
          (click)="select(g.name)"
        >
          <div style="min-width: 100px; display: flex">
            <mat-icon *ngIf="selected(g.name)">check</mat-icon>
            {{ g.name }}
          </div>
          <mat-divider></mat-divider>
        </mat-list-item>
      </mat-nav-list>

      <input mat-input [(ngModel)]="groups.inputValue" />
    </div>
  </div>
  <mat-dialog-actions>
    <button mat-raised-button color="warning" (click)="cancel()">
      {{ settings.lang.cancel }}
    </button>
    <button mat-raised-button color="accent" (click)="confirm()">
      {{ settings.lang.save }}
    </button>
  </mat-dialog-actions>
</div>
